<template>

  <div class="accounts-main">

    <div align="right">
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-light dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          {{ me.name }}
        </button>
        <div
          class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            type="button"
            @click="exit()">Sair</button>
        </div>
      </div>
    </div>

    <hr>

    <creating
      v-if="creating"
      height="100%" />

    <div
      class="card"
      v-if="!creating">
      <div class="card-header">
        <h5>{{ $t('Accounts') }}</h5>
      </div>

      <div
        class="list-group list-group-flush"
        v-if="accounts.length">
        <my-account-item
          v-for="(item, index) in accounts"
          :key="index"
          :account="item">
          </my-account-item>
      </div>

      <div
        class="card-body"
        v-if="!accounts.length">
        Não há contas para esse perfil
      </div>

    </div>
  </div>
  
</template>

<script>
import MyAccountItem from './MyAccountItem'

export default {
  name: 'MyAccount',
  components: {
    MyAccountItem
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    me () {
      return this.$store.getters.getMe
    },
    accounts () {
      return this.$store.getters.getAccounts
    }
  },
  metaInfo () {
    return {
      title: 'Minhas contas'
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('selectAccounts', {
        sort: '-created_at'
      })
      .then((result) => {
        this.creating = false
      })
    },
    exit () {
      this.$store.dispatch('authLogout')
      this.$router.push('/auth')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.accounts-main {
  max-width: 600px;
  margin: 20px auto; 
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/MyAccount.vue